import { Box, Paper, Typography } from "@mui/material";
import React from "react";

const ReviewFormType = () => {
  return (
    <Box mt={2} >
      <Typography variant="h6" fontSize="16px" fontWeight={800} mb={1} sx={{opacity:"0.9"}}>Forms</Typography>
      <Paper elevation={3} sx={{padding:"16px",backgroundColor:"#F6F7FA"}}>
        <Typography variant="h6" fontSize="14px" fontWeight={800} sx={{opacity:"0.8"}}>Manager Review Form</Typography>
      </Paper>
    </Box>
  );
};

export default ReviewFormType;
